import { render } from "./icon-merge.vue?vue&type=template&id=227a8bf4"
import script from "./icon-merge.vue?vue&type=script&lang=js"
export * from "./icon-merge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__